// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trans[data-v-2f1a5eb0] {\n  transition: top 0.5s, left 0.5s, right 0.5s, bottom 0.5s;\n}\n.chaos[data-v-2f1a5eb0] {\n  transition: top 0.5s, left 0.5s, right 0.5s, bottom 0.5s;\n}\n", ""]);
// Exports
module.exports = exports;
